export const PRICE_SCALE_MODE_KEY = "vnsc_priceScaleMode:price";
export function toEngineMode(mode) {
    return mode === "auto" ? "linear" : mode;
}
export function fromEngineMode(mode) {
    if (mode === "log")
        return "log";
    if (mode === "percent")
        return "percent";
    return "auto";
}
export function readStoredScaleMode() {
    try {
        /* eslint-disable-next-line no-restricted-globals -- scale-mode storage adapter (SSR-guarded typeof check; same key as useScaleOverlays) */
        const raw = typeof localStorage !== "undefined" ? localStorage.getItem(PRICE_SCALE_MODE_KEY) : null;
        return raw === "log" || raw === "percent" || raw === "linear" ? raw : null;
    }
    catch {
        return null;
    }
}
export function writeStoredScaleMode(mode) {
    try {
        /* eslint-disable-next-line no-restricted-globals -- scale-mode storage adapter (SSR-guarded; same key as useScaleOverlays) */
        if (typeof localStorage !== "undefined")
            localStorage.setItem(PRICE_SCALE_MODE_KEY, mode);
    }
    catch {
        // Private mode — state only.
    }
}
